import { Dropdown, Option } from "@fluentui/react-components";
import { OverflowTooltip } from "../OverflowTooltip/OverflowTooltip";
import { useStyles } from "./multipleChoicePicker.styles";
import { IMultipleChoicePickerProps } from "./multipleChoicePicker.types";

export const MultipleChoicePicker = ({
  accentPalette,
  options,
  selectedValues,
  placeholder,
  isMultiselect = true,
  disabled,
  onSelectionChange,
}: IMultipleChoicePickerProps): JSX.Element => {
  const styles = useStyles();

  const selectedText = selectedValues
    .map((value) => options[value])
    .filter(Boolean)
    .join(", ");

  return (
    <div className={styles.wrapper}>
      <OverflowTooltip text={selectedText} overflowSelector="button">
        <Dropdown
          multiselect={isMultiselect}
          selectedOptions={selectedValues}
          value={isMultiselect ? undefined : selectedText}
          disabled={disabled}
          placeholder={placeholder}
          onOptionSelect={(_, data) => {
            onSelectionChange(data.selectedOptions);
          }}
          style={{
            width: "100%",
            ...(accentPalette
              ? {
                borderColor: accentPalette.accentOnWhite,
              }
              : {}),
          }}
        >
          {Object.entries(options).map(([value, option]) => {
            const selectedPalette = selectedValues.includes(value)
              ? accentPalette
              : undefined;

            return (
              <Option
                key={value}
                value={value}
                text={option}
                checkIcon={{
                  style: {
                    backgroundColor: isMultiselect ? selectedPalette?.accent : undefined,
                    borderColor: isMultiselect ? selectedPalette?.accent : undefined,
                    color: selectedPalette?.accentText,
                  },
                }}
              >
                {option}
              </Option>
            );
          })}
        </Dropdown>
      </OverflowTooltip>
    </div>
  );
};
